export default __webpack_public_path__ + "static/media/alexandergarden.610d2c50.jpg";